import { render, staticRenderFns } from "./OrderTtn.vue?vue&type=template&id=5321dc6e&scoped=true"
import script from "./OrderTtn.vue?vue&type=script&lang=js"
export * from "./OrderTtn.vue?vue&type=script&lang=js"
import style0 from "./OrderTtn.vue?vue&type=style&index=0&id=5321dc6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5321dc6e",
  null
  
)

export default component.exports